import { getMessages } from '../../../../../../store/constants';

export const CARD_PROGRESS_TOOLTIP_EMPTY = getMessages().getText('card-progress.tooltip.empty');
export const CARD_PROGRESS_TOOLTIP_DONE = getMessages().getText('card-progress.tooltip.done');
export const CARD_PROGRESS_TOOLTIP_PROGRESS = getMessages().getText('card-progress.tooltip.progress');
export const CARD_PROGRESS_TOOLTIP_CREATED = getMessages().getText('card-progress.tooltip.created');
export const CARD_PROGRESS_TOOLTIP_CARD_DONE = getMessages().getText('card-progress.tooltip.card_done');
